export default __webpack_public_path__ + "static/media/acb.ec8ea6f1.webp";